export default __webpack_public_path__ + "static/10.04-1-28c703c21aea9f4158de50257a7080ec.png";